import React, { useState, useEffect } from 'react';
import StarField from './StarField';

const HeroSection = () => {
  const words = ['Designing', 'Building', 'Creating', 'Modding'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(false);
      setTimeout(() => {
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
        setIsAnimating(true);
      }, 300);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden">
      {/* Star field */}
      <StarField density="dense" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center">
          <div className="h-32 md:h-40 flex items-center justify-center overflow-hidden">
            <h1
              className={`text-5xl md:text-8xl font-light text-white tracking-tight transition-all duration-500 ${
                isAnimating
                  ? 'opacity-100 translate-x-0'
                  : 'opacity-0 -translate-x-full'
              }`}
            >
              {words[currentWordIndex]}
            </h1>
          </div>
          <p className="text-xl md:text-2xl text-gray-400 font-light tracking-wide mt-4">
            Custom Watch Builds
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
